const state = {
  data: [],
  needReload: false,
  param: {
    filter: {},
    sort: [{ field: 'logNo', order: 'DESC' }],
  },
  totalCount: 0,
  totalPages: 0,
}

const actions = {
  GET_LOG: ({ commit }, params) => {
    commit('MUTATION_GET_LOG', params);
  },
  // DOWNLOAD_LOG: ({ commit }, params) => {
  //   commit('MUTATION_DOWNLOAD_LOG', params);
  // },
}

const mutations = {
  MUTATION_GET_LOG: (state, payload) => {
    if (payload && payload.data && payload.data.list) {
      const { offset, limit } = payload.config.params;

      // 전체 목록 수
      const totalCount = payload.data.list.length > 0 ? payload.data.list[0].rnum + offset : 0;
      // 전체 페이지 수
      const totalPages = Math.ceil(totalCount / limit);

      state['data'] = payload.data.list[0];
      state['needReload'] = false;
      state['totalCount'] = totalCount;
      state['totalPages'] = totalPages;
    }
  },
  // MUTATION_DOWNLOAD_LOG: (state, payload) => {
  //   state['needReload'] = true;
  // },
}

const getters = {
  STATE: (state) => {
    return state;
  },
  DATA: (state) => {
    return state['data'];
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}